import { useEffect, useRef, useState } from 'react'

/**
 * Launcher «Sistemas Grupo Mecsa»: el menú waffle que salta entre sistemas.
 *
 * Es la versión React del componente canónico del Design System
 * (DesignSystemMecsa/starter/components/gm_launcher.php). La lista de sistemas
 * y el CSS (.topbar-apps, .apps-panel, …) se mantienen iguales a propósito:
 * si allá se agrega un sistema, se copia la lista de acá.
 *
 * Marca el sistema actual comparando el dominio, igual que la versión PHP.
 */

const LOGOS = 'https://ops.grupomecsa.net/assets/sistemas'

const SISTEMAS = [
  { name: 'Tickets', url: 'https://tickets.grupomecsa.net', icon: 'fa-ticket', color: '#2563eb' },
  { name: 'It Manager', url: 'https://itmanager.grupomecsa.net', icon: 'fa-server', color: '#0891b2', logo: `${LOGOS}/itmanager.svg` },
  { name: 'Operaciones', url: 'https://ops.grupomecsa.net', icon: 'fa-gears', color: '#dc2626', logo: `${LOGOS}/ops.svg` },
  { name: 'Chat / CRM', url: 'https://chat.grupomecsa.net', icon: 'fa-comments', color: '#25D366', logo: 'https://chat.grupomecsa.net/assets/mecsachat-icon.svg' },
  { name: 'CMS (Website)', url: 'https://koracms.com/cms/login.php', icon: 'fa-globe', color: '#16a34a', logo: `${LOGOS}/cms.png` },
  { name: 'Sicop', url: 'https://sicop.grupomecsa.net', icon: 'fa-file-contract', color: '#7c3aed' },
  { name: 'Talento Humano', url: 'https://rh.grupomecsa.net', icon: 'fa-users', color: '#d97706', logo: `${LOGOS}/rh.png` },
  { name: 'IA', url: 'https://mecsaai.grupomecsa.net', icon: 'fa-robot', color: '#db2777' },
  { name: 'Proyectos', url: 'https://proyectos.grupomecsa.net', icon: 'fa-diagram-project', color: '#c026d3', logo: `${LOGOS}/proyectos.svg` },
  { name: 'KPIs', url: 'https://kpis.grupomecsa.net', icon: 'fa-chart-column', color: '#ca8a04' },
  { name: 'Documentos', url: 'https://mecsadocs.grupomecsa.net', icon: 'fa-folder-open', color: '#0d9488' },
  { name: 'Universidad', url: 'https://universidad.grupomecsa.net', icon: 'fa-graduation-cap', color: '#4f46e5' },
  { name: 'Pulpería', url: 'https://pulperia.grupomecsa.net', icon: 'fa-basket-shopping', color: '#65a30d' },
  { name: 'Web / Tienda', url: 'https://www.grupomecsa.net', icon: 'fa-shop', color: '#0ea5e9' },
]

const GmLauncher = () => {
  const [abierto, setAbierto] = useState(false)
  const wrapRef = useRef(null)
  const host = typeof window !== 'undefined' ? window.location.host : ''

  // Se cierra al tocar fuera o con Escape, igual que el del Design System.
  useEffect(() => {
    if (!abierto) return
    const fuera = (e) => {
      if (!wrapRef.current?.contains(e.target)) setAbierto(false)
    }
    const escape = (e) => {
      if (e.key === 'Escape') setAbierto(false)
    }
    document.addEventListener('click', fuera)
    document.addEventListener('keydown', escape)
    return () => {
      document.removeEventListener('click', fuera)
      document.removeEventListener('keydown', escape)
    }
  }, [abierto])

  return (
    <div className="topbar-apps" ref={wrapRef}>
      <button
        className="topbar-apps-btn"
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          setAbierto((v) => !v)
        }}
        title="Sistemas Grupo Mecsa"
        aria-label="Sistemas Grupo Mecsa"
        aria-expanded={abierto}
      >
        <i className="fas fa-th"></i>
      </button>

      <div className={`apps-panel${abierto ? ' show' : ''}`}>
        <div className="apps-title">Sistemas Grupo Mecsa</div>
        <div className="apps-grid">
          {SISTEMAS.map((s) => {
            const actual = host !== '' && new URL(s.url).host === host
            return (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`apps-item${actual ? ' current' : ''}`}
                title={s.name}
              >
                {s.logo ? (
                  <span className="apps-ico apps-ico-logo">
                    <img src={s.logo} alt={s.name} loading="lazy" />
                  </span>
                ) : (
                  <span className="apps-ico" style={{ background: s.color }}>
                    <i className={`fas ${s.icon}`}></i>
                  </span>
                )}
                <span className="apps-name">{s.name}</span>
              </a>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default GmLauncher
